export const CHANGE_VALUE_INPUT = "CHANGE_VALUE_INPUT";
export const LOGIN = "LOGIN"
export const EMPRESAS = "EMPRESAS"
export const POWERBI = "POWERBI"
export const TOKEN_POWERBI = "TOKEN_POWERBI"
export const MOBILE_POWERBI = 'MOBILE_POWERBI'